import { render } from "./DbAccessControl.vue?vue&type=template&id=6541b2db"
import script from "./DbAccessControl.vue?vue&type=script&lang=js"
export * from "./DbAccessControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__